import { CustomerTag } from '@fgb/core';

export class Tags {
  public static STH = new CustomerTag(undefined, undefined, 'All Adult STHs');
  public static Member = new CustomerTag(undefined, undefined, 'All Adult Members');
  public static JuniorMembers = new CustomerTag(undefined, undefined, 'All Junior Members');
  public static AdultSTH = new CustomerTag(undefined, undefined, 'All Adult STHs');
  public static JuniorSTH = new CustomerTag(undefined, undefined, 'All Junior STHs');
}
